<script>
  let logos = ["static/images/special-images/Cioetto.png", "static/images/special-images/Guernieri.png", "static/images/special-images/LogoEAE-2C-01.png", "static/images/special-images/PSTV.png", "static/images/special-images/UNIPD.png"];
  let photos = ["static/images/special-images/img1.png", "static/images/special-images/img2.png", "static/images/special-images/img3.png"];
  let videos = ["static/images/special-images/Video1.mp4"];
</script>

<div class="container regionepiugrande">
  <div class="row mb-l header-images">
    <div class="col-8">
      <img src="static/images/special-images/POR-FESR_01_LOGO_Colori_Verticale.png" alt="" />
    </div>
    <div class="col-4 second-header-image">
      <img src="static/images/special-images/unaregionepiugrande.png" alt="" />
    </div>
  </div>
  <hr />
  <div class="logo-row mt-l mb-l">
    {#each logos as logo}
      <img src={logo} alt="" />
    {/each}
  </div>
  <hr />
  <div class="row mt-l">
    <div class="col-8">
      <div>
        <h1>Asse 1 Azione 1.1.4</h1>
        <div>Metodo di Progettazione e Produzione in Additive Manufacturing di componenti complessi del settore delle Giostre M.P.M.A.G</div>
      </div>
      <div>
          <div class="mb-l">Obiettivi del progetto: </div>
          <div class="mb-l">E’ stato sviluppato un metodo sperimentale di progettazione e di produzione in Additive Manufacturing di componenti complessi e diffusi nel settore delle giostre attraverso algoritmi di analisi volumetrica, cinematiche e topologica al fine di produrre un prototipo di componente ottimale in proprietà strutturali per essere realizzato con manifattura additiva. Sono stati realizzati prototipi di seduta per giostre realizzati con tecnologie in DED (direct laser deposition) e in SLM; realizzati i componenti secondari al fine di realizzare l’intera seduta allestita e provata su giostra. </div>
          <div class="mb-l">Sono stati studiati i possibili impatti che tale prototipo di componente ha sulla riduzione della struttura dell'intera giostra e dei meccanismi di operatività e del consumo energetico, con analisi effettuata mediante riprogettazione dell'intera giostra inserendo il componente prototipale progettato. </div>
          <div class="mb-l">Obiettivo indiretto è stato valutare l'impatto che la realizzazione di prodotti con manifattura additiva ha nelle imprese di meccanica di precisione operanti con le normali attrezzature a 4 o 5 assi. </div>
          <div class="mb-l">La sperimentazione ha definito e realizzato un sistema IOT con nuovo algoritmo per validare alcune proprietà dinamiche della giostra esempio analizzando il gap tra analisi delle curve e proprietà cinematiche teoriche stabilite in fase di progettazione e le risultanze cinematiche e curve ottenute dal funzionamento reale. </div>
          <div  class="mt-xl">
            <strong>Importo del sostegno</strong>: 324.844,28€
          </div>
      </div>
    </div>
    <div class="col-4">
      {#each photos as photo}
        <img src={photo} alt="" />
      {/each}

      {#each videos as video}
        <video src={video} alt="" controls>
          <source src={video} type="video/mp4" />
        </video>
      {/each}
    </div>
  </div>
</div>

<style>
  .header-images {
    display: flex;
    align-items: baseline;
  }
  .header-images .second-header-image img {
    max-height: 90px;
  }
  .header-images img {
    max-height: 150px;
  }
  .regionepiugrande img,
  .regionepiugrande video {
    max-width: 100%;
  }
  .logo-row {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .logo-row img {
    height: 50px;
  }
</style>
